<div class="fonts">
    <div *ngIf="membershipsUpdated" class="alert alert-success text-style">Memberships saved successfully!</div>
    <div *ngIf="settingsUpdated" class="alert alert-success text-style">Membership preference(s) saved successfully!
    </div>
    <div *ngIf="settingsReset" class="alert alert-success text-style">Membership preference(s) deleted successfully!
    </div>
    <div *ngIf="deleteSuccess" class="alert alert-success text-style">Membership removed successfully!</div>
    <div class="alert alert-danger" *ngIf="timeOutError"> {{timeoutErrorMessage}}</div>
    <div class="row container-fluid overall-margin">
        <div class="col-md-12" [ngClass]="{'fontFamily-margin': true}">
            <div class="col-md-12 col-xs-12 col-sm-12 heading">
                <span class="span-create-edit-hoshin color">BPG Membership Application - Group Sign Up</span>
                <span class="pt-1" style="font-size: 13px;"><a href="assets/userguides/GroupMembershipSignUpUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
            </div>
            <div class="col-sm-6 col-lg-6 col-md-6 col-xs-6 mt-2 mb-2" style="display:inline-flex">
                <button class="btn btn-danger col-sm-6 col-md-5 col-lg-4 col-xl-3 m-1 curve-edge button-font"
                    [ngClass]="{'disableSection': showPastEnrollments}" (click)="getNewSignUpDetails()">New Sign Up
                </button>
                <button
                    class="btn btn-danger col-sm-8 col-md-6 col-lg-4 col-xl-4 m-1 curve-edge button-font margin-left"
                    [ngClass]="{'disableSection': showNewSignUp}" (click)="getPastEnrollmentDetails()">Past Enrollments
                </button>
            </div>
            <div *ngIf="showNewSignUp && !showBpgSettings" class="mt-2 mb-3 ml-4 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Section to sign up Team members with Badge Scanner.</span>
            </div>
            <div *ngIf="showBpgSettings" class="mt-2 mb-3 ml-2 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Select Applicable membership for Group Sign ; Once done proceed to Team Member enrollment.</span>
            </div>
            <div *ngIf="showPastEnrollments" class="mt-2 mb-3 ml-2 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Section to view completed Enrollments.</span>
            </div>
        </div>
        <!-- part 2 -->
        <div *ngIf="showNewSignUp && !showBpgSettings" class="col-12 mb-5">
            <div class="col-12 ml-2 row">
                <div class="col-md-5 form-row text-style label-padding row">
                    <div class="col-4 pt-3 font-weight-bold">Badge ID</div>
                    <div class="div-style col-8">
                        <input #input type="text" class="form-control" placeholder="Scan/Enter TM BadgeId"
                            [(ngModel)]="badgeId" class="form-control deviceid-input" id="badgeId" maxlength="6"
                            (keyup)="fetchUserDetails('badge',$event)">
                    </div>
                </div>
                <div class="col-md-2 text-style text-center p-3">OR</div>
                <div class="col-md-5 form-row text-style label-padding row">
                    <div class="col-4 pt-3 font-weight-bold">Workday ID</div>
                    <div class="div-style col-8">
                        <input type="text" placeholder="Enter TM WorkdayId" [(ngModel)]="workdayId"
                            class="form-control deviceid-input" id="workdayId" maxlength="6"
                            (keyup)="fetchUserDetails('workday',$event)">
                    </div>
                </div>
            </div>
            <div *ngIf="showTeamMemberDetials" class="col-12 m-0 text-style">
                <!-- card -->
                <div class="card m-4">
                    <div class="m-4 margin-left">
                        <div class="margin-left mt-2">
                            <span class="team-member-details">Team Member Details</span>
                        </div>
                        <div class="margin-left">
                            <div class="mt-4 mb-2 mb-sm-1 mb-md-1 col-12 row">
                                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 p-2 pl-0 row">
                                    <div class="col-5">First Name</div>
                                    <div class="col-7 font-weight-bold">{{memberFirstName}}</div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 p-2 pl-0 row">
                                    <div class="col-5 col-lg-4 col-xl-4">Last Name</div>
                                    <div class="col-7 col-lg-8 col-xl-8 font-weight-bold">{{memberLastName}}</div>
                                </div>
                            </div>
                            <div class="mt-sm-1 mt-md-1 mb-sm-1 mb-md-1 mt-2 mb-2 col-12 row">
                                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 p-2 row">
                                    <div class="col-5">Workday ID</div>
                                    <div class="col-7 font-weight-bold">{{memberWorkdayId}}</div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 p-2 row">
                                    <div class="col-5 col-lg-4 col-xl-4">Badge ID</div>
                                    <div class="col-7 col-lg-8 col-xl-8 font-weight-bold">{{memberBadgeId}}</div>
                                </div>
                            </div>
                            <div class="mt-sm-1 mt-md-1 mt-2 mb-4 col-12 row">
                                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 p-2 row">
                                    <div class="col-5">Site Location</div>
                                    <div class="col-7 font-weight-bold">{{membersiteName}}</div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 p-2 row">
                                    <div class="col-5 col-lg-4 col-xl-4">Email Id</div>
                                    <div class="col-7 col-lg-8 col-xl-8 font-weight-bold">{{memberEmailId}}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!memberEmailId" class="margin-left pl-2 mb-5">
                            <p><b>Missing Email Address :</b></p>
                            <p class="mt-2">Your email address is missing. Please update to receive all Chapter
                                Membership
                                related notifications.</p>
                            <div class="col-md-12 row mt-4 p-0">
                                <div class="col-md-6">
                                    <input type="text" style="background: white;" class="form-control deviceid-input"
                                        placeholder="Please enter email address" [(ngModel)]="emailAddress"
                                        (keyup)="checkEmailType($event)">
                                    <p class="text-medium-style color margin-left pt-2 mb-2" *ngIf="isEmailInvalid">Please
                                        enter a valid
                                        email
                                        address</p>
                                </div>
                                <div class="col-md-6 margin-top">
                                    <input type="text" style="background: white;" class="form-control deviceid-input"
                                        placeholder="Confirm email address" [disabled]="!emailAddress"
                                        [(ngModel)]="recheckEmailAddress" (keyup)="RecheckEmailType($event)">
                                    <p class="text-medium-style color margin-left pt-2 mb-2" *ngIf="isEmailNotMatching">
                                        EmailId Mismatch!</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- memberships -->
                <div *ngIf="siteId!=1" class="mt-sm-4 mt-md-5 mt-lg-5 5 mt-xl-5 col-md-12">
                    <p class="text-center mb-4">Available Memberships for Sign up at <span
                            class="font-weight-bold pr-2"><b>{{siteLocation}}</b></span><span class="color"
                            (click)="viewBPGSettings()" style="cursor: pointer; font-size: 12px;">Click here to
                            Configure</span></p>
                    <div class="row col-12 mt-sm-3 mt-md-5 mt-lg-5 mt-xl-5 pl-md-5 pl-lg-5 pl-xl-5 pl-sm-5">
                        <div class="col-sm-12 col-md-6 p-1 col-lg-6 col-xl-6 div-top"
                            *ngFor="let bpg of bpgList ; let i of index">
                            <div *ngIf="!bpg.isUserAlreadyMember" class="font-family pl-4"><label
                                    for="check{{bpg.bpgName}}" style="display:inline-flex">
                                    <input type="checkbox" name="check{{bpg.bpgName}}" [checked]="bpg.userSpecific"
                                        name="check{{bpg.bpgName}}" id="check{{bpg.bpgName}}"
                                        (change)="toggleCheckboxForUser($event,bpg)">
                                    <span class="label-text"></span>
                                    <span *ngIf="!bpg.showFullWord"
                                        class="text-style margin-left right-align">{{bpg.minWord}}</span>
                                    <span *ngIf="bpg.showFullWord"
                                        class="text-style margin-left right-align">{{bpg.bpgName}}</span>
                                </label>
                            </div>
                            <div *ngIf="bpg.isUserAlreadyMember" class="font-family pl-4"><label class="pl-3"
                                    style="display:inline-flex">
                                    <span class="label-text"></span>
                                    <span *ngIf="!bpg.showFullWord"
                                        class="text-style margin-left right-align">{{bpg.minWord}}
                                        <span class="color pl-1">(already a member)</span></span>
                                    <span *ngIf="bpg.showFullWord"
                                        class="text-style margin-left right-align">{{bpg.bpgName}}
                                        <span class="color pl-1">(already a member)</span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- submit button -->
                <div class="mt-4 col-12 text-center">
                    <p *ngIf="isEmailNotMatching" class="color">The email addresses do not match. Please correct them to update.</p>
                    <button [disabled]="disableSubmitButton" data-toggle="modal" data-target="#myModal"
                        class="btn btn-danger curve-edge col-2 col-md-2 m-1 button-font"
                        (click)="saveGroupMembership()">Submit</button>
                </div>
            </div>
            <div class="mt-5 text-style text-center color" *ngIf="userNotFound">
                <b>No user found !</b>
            </div>
        </div>

        <!-- bpg settings page -->
        <div class="col-12 mb-5 text-style" *ngIf="showBpgSettings">
            <div class="col-12 row container">
                <div class="col-md-6 col-sm-12 col-xs-12 col-lg-6 col-xl-6">
                    <p class="pl-1 font-weight-bold">Select the applied Membership for all users ?</p>
                    <div class="col-12 p-0" *ngFor="let bpg of bpgList ; let i of index">
                        <div class="font-family pl-2"><label for="check{{bpg.bpgName}}" style="display:inline-flex">
                                <input type="checkbox" name="check{{bpg.bpgName}}" [checked]="bpg.checked"
                                    name="check{{bpg.bpgName}}" id="check{{bpg.bpgName}}"
                                    (change)="toggleCheckbox($event,bpg)">
                                <span class="label-text"></span>
                                <span class="text-style margin-left right-align">{{bpg.bpgName}}</span>
                            </label>
                        </div>
                    </div>
                </div>
             
            </div>
            <div class="mt- text-center col-12 p-0">
                <div class=" mt-5 col-12">
                    <button data-toggle="modal" data-target="#myModal" [disabled]="disableSaveButton"
                        class="btn btn-danger curve-edge col-2 col-md-2 m-1 button-font" (click)="save()">
                        Save and Update
                    </button>
                    <button data-toggle="modal" data-target="#myModal" [disabled]="disableResetButton"
                        class="btn btn-danger curve-edge col-2 col-md-2 m-1 button-font" (click)="reset()">
                        Delete
                    </button>
                    <button class="btn btn-danger curve-edge col-2 col-md-2 m-1 button-font" (click)="cancel()">
                        Back
                    </button>
                </div>
            </div>
        </div>
        <!-- grid page -->
        <div *ngIf="showPastEnrollments" class="col-md-12">
            <div style="display: inline-flex;" class="col-12">
                <div class="col-5" style="float: left;">
                    <!-- #searchInput -->
                    <input type="text" [(ngModel)]="searchText" (keyup)="onKey($event.target)"
                        placeholder="Search by TM Name" class="col-9 pl-4 form-control deviceid-input">
                </div>
                <div class="col-7 pr-0" style="display: inline-flex;text-align: end;">
                    <p class="col-12 pt-3 pr-0">
                        <span class="p-2 pointer" [ngClass]="{'highlightFilter': showAll}"
                            (click)="filterBy('All',true)">
                            All
                        </span>
                        <span class="p-2 pointer" [ngClass]="{'highlightFilter': showByToday}"
                            (click)="filterBy('Today',true)">
                            Today
                        </span>
                        <span class="p-2 pointer" [ngClass]="{'highlightFilter': showByMonth}"
                            (click)="filterBy('Month',true)">
                            This Month
                        </span>
                        <span class="p-2 pointer" [ngClass]="{'highlightFilter': showByYear}"
                            (click)="filterBy('FiscalYear',true)">
                            Current FY
                        </span>
                    </p>
                </div>
            </div>
            <!-- table -->
            <div class="mt-4">
                <p class="noDataFound text-center color" *ngIf="noDataFound"> No record found ! </p>
                <div id="tabledemo1" *ngIf="tableShow">
                    <div class="table-container pl-4">
                        <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}"
                            class="table table-striped" id="tabledemo">
                            <thead>
                                <tr class="tr-th">
                                    <th scope="col">Team Member</th>
                                    <th scope="col">Email Address</th>
                                    <th scope="col">Chapters</th>
                                    <th scope="col">Enrolled</th>
                                    <th scope="col">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let data of enrollmentList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
                                    <td>{{data.name}}</td>
                                    <td>{{data.emailId}}</td>
                                    <td>
                                        <span class="font-weight-bold">{{data.bpgName}}</span>
                                    </td>
                                    <td>{{data.date}}</td>
                                    <td style="padding-top:13px !important">
                                        <a (click)="delete(data)" data-toggle="modal" data-target="#myModal"
                                            class="edit-delete" data-toggle="modal"><img src="assets/images/delete.png"
                                                class="image" title="Delete" alt="Angular Logo"></a>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
                        <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
                        <pagination-controls previousLabel="Prev" nextLabel="Next"
                            (pageChange)="pageChanged($event)"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
</div>